import React from 'react';

const WithWhatsapp = ({ number,wa }) => {
	return (
		<div style={{ padding: "10px", backgroundColor: "#fff" }}>
			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{number}</span>
			<div style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10 }}>
				<a style={{ padding: "10px", borderRadius: "10px" }}
					href={`https://wa.me/977${wa}?span=
  नमस्ते Angel Education Consultancy 🙏
  म Angel Education Consultancy को प्रयोगकर्ता हुँ। यहाँ APPमा मेरो डाटा छ।
  `
					}
				>
					<span>
						<i className="fa fa-whatsapp" style={{ fontSize: 30 }} />
					</span>
				</a>
				<a style={{ padding: 10, borderWidth: 0.5, borderColor: "#ddd", borderRadius: 10 }}
					href={`tel:${number}`}
				>
					<span>
						<i className="fa fa-phone" style={{ fontSize: 30 }} />
					</span>
				</a>
			</div>
		</div>
	)
}
const WithoutWhatsapp = ({ number }) => {
	return (
		<div>
			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{number}</span>
			<div style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10 }}>
				<a style={{ padding: 10, borderWidth: 0.5, borderColor: "#ddd", borderRadius: 10 }}
					href={`tel:${number}`}
				>
					<span>
						<i className="fa fa-phone" style={{ fontSize: 30 }} />
					</span>
				</a>
			</div>
		</div>
	)
}


export default function ContactUS({title}) {
	return (
		<div className='row'>
			<div className="row">

				<div className="col-lg-2 col-1"></div>
				<div className="col-lg-8 col-10 shadow signin-container" style={{ backgroundColor: "#fff" }}>

					<div>
						<div style={{ backgroundColor: "#fff", borderColor: "#bbb", borderWidth: 1, margin: 10, padding: 10 }}>
							<span style={{ spanAlign: "center" }}>
								तपाईले {title} access को लागि दिएको qr मा payment गरी तल continue मा click सम्पर्क गर्नु होला वा whatsapp मा सम्पर्क गर्नु होला
							</span>
						</div>
						<div className='row'>
							<div className='col-sm-6'>
								<img src='https://api.akbeducation.com/wp-content/uploads/2025/11/Screenshot-2025-11-09-at-14.04.15.png'
									style={{ height: "300px" }}
								/>
								Account No : 03201007976607000001<br />
								Name: Toran Bhandari Chhetri<br />
								Bank : Nepal Bank Limited<br />

							</div>
							<div className='col-sm-6'>
								<img src='https://api.akbeducation.com/wp-content/uploads/2025/11/Screenshot-2025-11-09-at-14.04.20.png'
									style={{ height: "300px" }}
								/>
								Esewa No: 9848254922<br />
								Name :  Toran Bhandari Chhetri
							</div>
						</div>
						<div style={{ backgroundColor: "#fff", borderColor: "#bbb", borderWidth: 1, margin: 10, padding: 10 }}>
							<span style={{ spanAlign: "center" }}>
								तपाई पहिलो पटक किन्दै हुनुहुन्छ वा कुनै समस्या परेमा  तल दिईएको सम्पर्क नम्बरमा सम्पर्क गर्नु  होला |{"\n"}
							</span>
						</div>
						<div style={{ display: 'flex' }}>
							<div style={{ width: "66%", borderColor: "#bbb", borderWidth: 1, padding: 10, margin: 10, marginTop: 0, backgroundColor: "#fff" }}>
								<span style={{ spanAlign: "left" }}>
									Head Office: Angel Korean, Bagbazar
								</span>
								<div style={{ display: 'flex' }}>
									<div style={{ width: "50%" }}>
										<WithWhatsapp number={"+977-9848254922"} wa={"9848254922"} />
									</div>
									<div style={{ width: "50%" }}>
										<WithoutWhatsapp number={"+977-015918637"} />
									</div>
								</div>
							</div>
							<div style={{ width: "33%", borderColor: "#bbb", borderWidth: 1, padding: 10, margin: 10, marginTop: 0, backgroundColor: "#fff" }}>
								<span style={{ spanAlign: "left" }}>
									QUESTION/ANSWER SUPPORT :
								</span>
								<div style={{ flexDirection: "row" }}>
									<div style={{ width: "100%" }}>
										<WithWhatsapp number={"+977-9703904229"} wa={"9703904229"} />
									</div>
								</div>
							</div>
						</div>



					</div>
				</div>
			</div>
		</div>
	)
}